import { DOMAIN } from './Userpilot.constants';
import get from 'lodash/get';

export const getStore = state => get(state, DOMAIN) || {};

export const getId = state => getStore(state).userpilotId;
export const getContentId = state => getStore(state).userpilotContentId;
